import { DatePicker as AntdDatePicker, Form, type FormItemProps } from 'antd';
import type { PickerMode } from 'rc-picker/lib/interface';

import type { Ii18nLabel } from '@/types/common';
import { getFormItemLabel } from './utils';

interface DatePickerProps extends FormItemProps, Ii18nLabel {
  showTime?: boolean;
  disabled?: boolean;
  picker: Exclude<PickerMode, 'date' | 'time'>;
}

export const DatePicker = ({ name, label, i18nLabel, rules, ...props }: DatePickerProps) => {
  const fieldLabel = getFormItemLabel(i18nLabel, label);

  return (
    <Form.Item name={name} label={fieldLabel} rules={rules}>
      <AntdDatePicker {...props} />
    </Form.Item>
  );
};
